module.exports = __webpack_public_path__ + "static/media/detail_0032_f.d82a03b4.jpg";